import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';

import { FehApiEffects } from './feh.ngrx-wrapper';
import { UtilApiEffects } from './util.ngrx-wrapper';

@NgModule({
  imports: [EffectsModule.forFeature(FehApiEffects, UtilApiEffects)],
})
export class FehSharedApiStoreModule {}
